import React, { useState } from "react";
import { Button, Paper, Menu, MenuItem } from "@mui/material";

const FloatNavBarMobile = (props) => {
    const { selectedCategory, setSelectedCategory, categoryList } = props;
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        handleMenuClose();
    };

    return (
        <Paper
            elevation={3}
            sx={{
                position: "fixed",
                bottom: 20,
                zIndex: 3,
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: 2,
                background: "rgba(0, 0, 0, 0.16)",
                borderRadius: "20px",
                backdropFilter: "blur(15px)",
                padding: "8px 17px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            }}
        >
            <Button
                onClick={handleMenuOpen}
                sx={{
                    padding: "13px 17px",
                    color: "#FFFFFF",
                    backgroundColor: "rgba(0,0,0,0.3)",
                    borderRadius: "14px",
                    textTransform: "none",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    transition: "all 0.3s ease",
                    "&:hover": {
                        background: "rgba(0,0,0,0.1)",
                    },
                }}
            >
                {selectedCategory || "Select Category"}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                sx={{
                    "& .MuiPaper-root": {
                        background: "rgba(0, 0, 0, 0.5)",
                        color: "#FFFFFF",
                        borderRadius: "10px",
                        backdropFilter: "blur(15px)",
                    },
                }}
            >
                {categoryList.map((item) => (
                    <MenuItem
                        key={item}
                        onClick={() => handleCategoryChange(item)}
                        sx={{
                            color: selectedCategory === item ? "#FFFFFF" : "#BEBEBE",
                            backgroundColor:
                                selectedCategory === item ? "rgba(0,0,0,0.3)" : "transparent",
                            "&:hover": {
                                background: "rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        {item}
                    </MenuItem>
                ))}
            </Menu>
        </Paper>
    );
};

export default FloatNavBarMobile;
